import Vue from 'vue';

const success = (data, resolve) => {
  resolve(data.data);
};

const failed = (errors, reject) => {
  if (errors.error) {
    reject(errors.error);
    return;
  }

  reject();
};

export default (id, kidNumber) => (
  new Promise((resolve, reject) => {
    Vue.$http.post(`/bills/${id}/validate_kid`, { kid_number: kidNumber })
    .then((response) => {
      success(response.data, resolve);
    })
    .catch((error) => {
      failed(error.response.data, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/bill/validateKID.js